import React, { FC, ReactNode } from 'react';
import { LeftBarWrapper } from '../page-registration/LeftBarWrapper';
import LanguageSwitcher from '../../controls/LanguageSwitcher/LanguageSwitcher';
import { useSignupWizard } from './signup-wizard-context';

const TOTAL_STEPS = 6;

interface WizardLayoutProps {
  children: ReactNode;
  showProgressDots?: boolean;
}

const WizardLayout: FC<WizardLayoutProps> = ({ children, showProgressDots = true }) => {
  const { state } = useSignupWizard();
  const { currentStep } = state;

  return (
    <LeftBarWrapper>
      {/* Override LeftBarWrapper's rightColumn padding to prevent the 1080px breakpoint jump */}
      <style>{`
        .wizard-layout-override {
          padding: 40px !important;
        }
        @media (min-width: 769px) {
          .wizard-layout-override {
            padding-top: 80px !important;
          }
        }
      `}</style>
      <div style={{ position: 'absolute', top: '1rem', right: '1rem' }}>
        <LanguageSwitcher />
      </div>
      <div className="w-full max-w-lg mx-auto px-4 md:px-6 pt-8 pb-4 flex flex-col items-center" ref={(el) => {
        // Tag the rightColumn parent so our style override applies
        if (el?.parentElement && !el.parentElement.classList.contains('wizard-layout-override')) {
          el.parentElement.classList.add('wizard-layout-override');
        }
      }}>
        {showProgressDots && (
          <div className="flex items-center gap-2 mb-8">
            {Array.from({ length: TOTAL_STEPS }, (_, i) => {
              const step = i + 1;
              const isFilled = step <= currentStep;
              return (
                <div
                  key={step}
                  style={{
                    width: '0.75rem',
                    height: '0.75rem',
                    borderRadius: '50%',
                    transition: 'background-color 200ms',
                    backgroundColor: isFilled ? 'var(--orange-500)' : 'var(--gray-200)',
                  }}
                />
              );
            })}
          </div>
        )}

        <div className="w-full">{children}</div>
      </div>
    </LeftBarWrapper>
  );
};

export default WizardLayout;
